import { useMemo, useRef } from 'react';

const SEPARATOR_KEYS = ['/', '-', '.'];

const DATE_PART_NAMES = ['month', 'day', 'year'];

const YEAR_FIRST = /^((?:19|20)\d{2})[-/.]$/;

const isDateSegment = (element) => element?.dataset?.input === 'true';

const isDigitKey = (key) => /^\d$/.test(key);

const setSegmentValue = (segment, value) => {
  Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(segment, value);
  segment.dispatchEvent(new Event('input', { bubbles: true }));
};

export const useSeparatorKeyDown = () => {
  const lastTypedSegmentRef = useRef(null);
  const typedFromEmptyRef = useRef(null);

  return useMemo(
    () => ({
      onPointerDownCapture: () => {
        typedFromEmptyRef.current = null;
      },
      onKeyDownCapture: (event) => {
        const segment = event.target;
        if (!isDateSegment(segment)) return;

        const segments = [...segment.parentElement.querySelectorAll('input[data-input="true"]')];
        const dateParts = segments.filter((input) => DATE_PART_NAMES.includes(input.name));
        const isDigit = isDigitKey(event.key);
        const isSeparator = SEPARATOR_KEYS.includes(event.key);

        const isDatePartKey = (isDigit || isSeparator) && dateParts.includes(segment);
        const startsEmptyDate =
          segment === dateParts[0] && dateParts.every((input) => !input.value);
        const typedSoFar = startsEmptyDate ? '' : typedFromEmptyRef.current;
        const typed = isDatePartKey && typedSoFar !== null ? typedSoFar + event.key : null;
        const isYearFirstCandidate = typed !== null && typed.length <= 'yyyy/'.length;
        typedFromEmptyRef.current = isYearFirstCandidate ? typed : null;

        if (isDigit) {
          lastTypedSegmentRef.current = segment;
          return;
        }
        if (!isSeparator) return;

        event.preventDefault();
        event.stopPropagation();

        const yearFirst = typedFromEmptyRef.current?.match(YEAR_FIRST);
        const yearSegment = dateParts.find((input) => input.name === 'year');
        if (yearFirst && yearSegment) {
          typedFromEmptyRef.current = null;
          dateParts.forEach((input) =>
            setSegmentValue(input, input === yearSegment ? yearFirst[1] : '')
          );
          lastTypedSegmentRef.current = null;
          dateParts[0].focus();
          return;
        }

        const isSegmentBeingTyped = lastTypedSegmentRef.current === segment && segment.value !== '';
        if (!isSegmentBeingTyped) return;

        segments[segments.indexOf(segment) + 1]?.focus();
      }
    }),
    []
  );
};
